<template>
    <div :class="['bo-dropdown-search', dropdownStyle]">
        <slot name="dropdown-trigger">
            <div
                class="bo-dropdown-toggle"
                data-toggle="dropdown"
                :disabled="!editable"
            >
                <slot
                    name="selected-item"
                    v-if="selectedItem"
                    :item="selectedItem"
                >
                    {{ selectedItem.label }}
                </slot>
                <slot
                    v-else
                    name="default-item"
                >
                </slot>
            </div>
        </slot>
        <div class="dropdown-menu quick-search">
            <div class="searchbar">
                <div class="btn-search"><i class="icon-search"></i></div>
                <input
                    type="text"
                    v-model="searchQuery"
                    :placeholder="placeholder"
                    class="search-input dropdown"
                />
                <!-- <button class="btn-reset">
                    <i class="icon-close" @click="resetSearch"></i>
                </button> -->
            </div>

            <slot name="addon-contents"></slot>

            <div class="popup-trigger">
                <div
                    class="quick-search-group"
                    v-for="listItem in resultQuery"
                    :key="listItem.index"
                >
                    <div
                        v-if="listItem.groupTitle"
                        class="group-title"
                    >
                        {{ listItem.groupTitle }}
                    </div>
                    <template v-for="item in listItem.items">
                        <div
                            class="dropdown-item"
                            :class="{ disabled: item.disabled }"
                            :key="item.index"
                            @click="select(item)"
                        >
                            <slot
                                name="item"
                                :item="item"
                            >
                                <span>{{ item.value }}</span>
                            </slot>
                        </div>
                    </template>
                </div>
                <slot name="after_items"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        items: {
            type: Array,
            default: [],
        },
        editable: {
            type: Boolean,
            default: true,
        },
        value: {
            type: Object,
            default: null,
        },
        dropdownStyle: {
            type: String,
            default: "",
        },
        placeholder: {
            type: String,
            default: window.bo?.generalTranslations?.search ?? "Search",
        },
    },
    model: {
        prop: "value",
        event: "change",
    },
    data: function () {
        return {
            searchQuery: null,
        };
    },
    computed: {
        selectedItem: {
            get() {
                return this.value;
            },
            set(newValue) {
                this.$emit("change", newValue);
            },
        },
        resultQuery() {
            if (this.searchQuery) {
                var result = [];
                this.items.forEach((element) => {
                    result.push({
                        items: element.items.filter((item) => {
                            return this.searchQuery
                                .toLowerCase()
                                .split(" ")
                                .every((v) => {
                                    if (typeof item["hasQuery"] == "function") {
                                        return item.hasQuery(v);
                                    }
                                    return item.value.toLowerCase().includes(v);
                                });
                        }),
                        groupTitle: element.groupTitle,
                    });
                });
                return result;
            } else {
                return this.items;
            }
        },
    },
    methods: {
        select(item) {
            if (item.disabled) {
                return;
            }
            this.selectedItem = item;
        },
        resetSearch() {
            this.searchQuery = null;
        },
    },
};
</script>
